export default "__VITE_ASSET__BH55pLr5__"